// angular
import {Injectable, inject} from "@angular/core";
import {Router} from "@angular/router";
import {AppSocket} from "@app/shared/services/socket-factory.service";
import {MatDialog} from "@angular/material/dialog";
// services
import {SocketFactory} from "@app/shared/services/socket-factory.service";
import {StorageService} from "./storage.service";
import {AppToastService} from "./app-toast.service";
// components
import {EmergencyWarningDialogComponent} from "@app/core/components/dialog/emergency-warning-dialog/emergency-warning-dialog.component";

export enum EmergencySocketEvents {
  EMERGENCY_ACTIVATED = "emergency-activated",
  EMERGENCY_RESTORED = "emergency-restored",
}

@Injectable({providedIn: "root"})
export class EmergencyService {
  private _emergencySocket?: AppSocket;

  // dependencies
  private _socketFactory = inject(SocketFactory);
  private _router = inject(Router);
  private _storageService = inject(StorageService);
  private _toast = inject(AppToastService);
  private _dialog = inject(MatDialog);

  constructor() {}

  /**
   * Initialize emergency socket connection
   * Should be called when user logs in
   */
  public initEmergencySocket(): void {
    try {
      this._emergencySocket = this._socketFactory.getSocket("emergency");
      this._listenToEmergencyEvents();
    } catch (error) {
      console.error("Failed to initialize emergency socket:", error);
    }
  }

  /**
   * Listen to emergency mode events
   */
  private _listenToEmergencyEvents(): void {
    const socket = this._emergencySocket;
    if (!socket) {
      return;
    }
    socket
      .fromEvent(EmergencySocketEvents.EMERGENCY_ACTIVATED)
      .subscribe(() => {
        this._handleEmergencyActivated();
      });

    socket.fromEvent(EmergencySocketEvents.EMERGENCY_RESTORED).subscribe(() => {
      this._toast.info("حالت اضطراری غیرفعال شد.");
    });
  }

  /**
   * Handle emergency mode activation
   * Shows dialog and logs out the user
   */
  private _handleEmergencyActivated(): void {
    // Open emergency warning dialog
    // const dialogRef = this._dialog.open(EmergencyWarningDialogComponent, {
    //   width: "400px",
    //   disableClose: true, // Prevent closing by clicking outside
    //   data: {
    //     title: "حالت اضطراری",
    //     message:
    //       "حالت اضطراری فعال شده است. شما از سیستم خارج خواهید شد و می‌توانید مجدداً وارد شوید.",
    //   },
    // });

    // When user clicks the button, perform logout
    // dialogRef.afterClosed().subscribe(() => {

    // });
    this._performLogout();
  }

  /**
   * Perform logout operations
   */
  private _performLogout(): void {
    // Clear user session
    this._storageService.removeToken();

    // Disconnect all sockets
    this._socketFactory.disconnectAll();

    // Redirect to login page
    this._router.navigate(["/login"]);
  }

  /**
   * Disconnect emergency socket
   * Should be called on logout
   */
  public disconnectEmergencySocket(): void {
    if (this._emergencySocket) {
      this._emergencySocket.disconnect();
    }
  }
}
